var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd-icon-button',{staticClass:"quick-add-button",attrs:{"title":_vm.title,"size":_vm.size,"color":_vm.color,"icon":"plus","type":"circle"}})}
var staticRenderFns = []

export { render, staticRenderFns }